import { useCallback } from "react";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import { useSearchParamState } from "@/common/hooks/nuqs/useSearchParamState.ts";
import { useModalQueryState } from "@/common/hooks/nuqs/useModalQueryState.ts";
import useKeyboardListener from "@/common/hooks/useKeyboardListener";

export const useKeyboardShortcutCreateFolder = (): void => {
  const [modalIsOpen] = useSearchParamState(URLSearchParamKeys.MODAL);
  const { setModalParam: setCreatePlaylistModalSearchParam } = useModalQueryState(URLSearchParamKeys.CREATE_PLAYLIST_MODAL);

  const openCreatePlaylistModal = useCallback(() => {
    setCreatePlaylistModalSearchParam("1");
  }, [setCreatePlaylistModalSearchParam]);

  useKeyboardListener((event) => {
    if (modalIsOpen) return;

    if (event.altKey && event.shiftKey && event.key === "ˆ") {
      event.preventDefault();
      openCreatePlaylistModal();
    }
  });
};
